<template>
    <bottom-sheet
            title="增加急件費用"
            description="加價使任務更快速地完成"
            @onCancel="onCancel"
            @onConfirm="checkTip"
            @onClose="onClose">
        <div class="input">
            <input type="number" v-model.number="tip" @keyup.enter="$event.target.blur()" placeholder="自訂金額" ref="tip">
<!--            <div v-show="tip" class="btn" @click="tip = ''">x</div>-->
            <img  v-show="tip" class="btn" @click="tip = ''" src="@/assets/img/cancel.svg">
        </div>
        <div class="select">
            <div class="item" @click="setTip(50)">$ 50</div>
            <div class="item" @click="setTip(100)">$ 100</div>
        </div>
        <div class="select">
            <div class="item" @click="setTip(150)">$ 150</div>
            <div class="item" @click="setTip(500)">$ 500</div>
        </div>
        <div v-if="canCancel" class="cancel" @click="clearTip">
            不增加費用
        </div>
        <tip-modal ref="modal" @onConfirm="onConfirm"/>
    </bottom-sheet>
</template>

<script>
    import BottomSheet from '../BottomSheet';
    import TipModal from '../modal/TipOverFiveHundredModal';

    export default {
        name: 'AddTip',
        components: {
            'bottom-sheet': BottomSheet,
            'tip-modal': TipModal,
        },
        props: {
            defaultTip: {
                default: 0,
            },
            canCancel: {
                default: false,
            }
        },
        data() {
            return {
                tip: undefined,
            };
        },
        methods: {
            checkTip() {
                if (this.tip > 500) {
                    this.$refs.modal.show(this.tip);
                    return;
                }

                this.onConfirm();
            },
            onConfirm() {
                this.$emit('onDone', Math.max(parseInt(this.tip), 0));
            },
            onClose() {
                this.$emit('onCancel');
            },
            onCancel() {
                this.$emit('onCancel');
            },
            setTip(tip) {
                this.tip = tip;
                this.onConfirm();
            },
            clearTip() {
                this.tip = '';
                this.$emit('onDone', this.tip);
            }
        },
        created() {
            if (this.defaultTip > 0) {
                this.tip = this.defaultTip
            }
        },
        watch: {
            tip() {
                if (this.tip !== Math.floor(this.tip)) {
                    this.tip = Math.floor(this.tip) || '';
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    input {
        border: 1px solid rgba(230,232,237,1);
        border-radius: 4px;
        background-color: rgba(255,255,255,1);
        width: calc(100% - 4px);
        height: 40px;
        text-align: center;
    }

    .cancel {
        border: 1px solid rgba(230,232,237,1);
        border-radius: 4px;
        width: calc(100% - 4px);
        height: 40px;
        text-align: center;
        margin-top: 10px;
        line-height: 40px;
    }

    .select {
        margin-top: 10px;
        display: flex;
        justify-content: space-around;

        .item {
            width: calc(50% - 7.5px);
            height: 40px;
            text-align: center;
            border: 1px solid rgba(230,232,237,1);
            border-radius: 4px;
            background-color: rgba(255,255,255,1);
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .input {
        position: relative;

        .btn {
            position: absolute;
            top: 0;
            right: 2px;
            height: 26px;
            width: 26px;
            line-height: 20px;
            margin: 10px;
        }
    }
</style>
